import React from "react";
import { Col, Modal, Image, Row } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import moment from "moment";

const ReviewDetails = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.showView}
        onHide={props.handleCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <Image
                //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                src={
                  props.review &&
                  props.review.restaurant_id &&
                  props.review.restaurant_id.logo_url
                }
                alt="restaurant logo"
                title="restaurant logo"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {" "}
                  {props.review &&
                    props.review.restaurant_id &&
                    props.review.restaurant_id.restaurant_name}
                  ’s Review
                </div>
                <div className="f14-400">
                  {props.review &&
                    props.review.restaurant_id &&
                    props.review.restaurant_id.restaurant_address}
                </div>
              </Col>
            </div>
          </div>
          <hr />
          <Row>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-start"
            >
              <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="super-admin-suggestion-imageBoxOne enIMG62 rounded-circle">
                  {props.review &&
                  props.review.user_id &&
                  props.review.user_id.profile_photo &&
                  props.review.user_id.profile_photo[0] ? (
                    <Image
                      fluid
                      //src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                      src={props.review.user_id.profile_photo[0]}
                      alt="Icon"
                    />
                  ) : (
                    <Image
                      fluid
                      src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                      //src={review.user_id.photos[0]}
                      alt="Icon"
                    />
                  )}
                </div>
                <div className="super-admin-suggestion-imageBoxTwo mt-2">
                  <div className="f12-400">
                    {props.review &&
                      props.review.user_id &&
                      props.review.user_id.first_name}{" "}
                    {props.review &&
                      props.review.user_id &&
                      props.review.user_id.last_name}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-center"
            >
              <div>
                <div className="f12-500 mb-1">
                  {props.review && props.review.rating} Stars
                </div>
                <ReactStars
                  count={5}
                  value={props.review && props.review.rating}
                  edit={false}
                  size={22}
                  half={true}
                  emptyIcon={<i className="fa fa-star-o"></i>}
                  halfIcon={<i className="fa fa-star-half-alt"></i>}
                  fullIcon={<i className="fa fa-star"></i>}
                  color2={"#FDD400"}
                />
                <div className="f10-500 mt-1">
                  {moment(props.review && props.review.createdAt).format(
                    "Do MMMM, YYYY, h:mm A"
                  )}
                </div>
              </div>
            </Col>
            <Col
              md={4}
              className="d-flex align-items-center justify-content-center"
            >
              {props.review &&
              props.review.diner_id &&
              props.review.diner_id.service_type ? (
                <div className="d-flex align-items-center">
                  <div className="image-box-new mr-2">
                    <Image
                      fluid
                      src={require("../../../../../assets/images/seatingImages/reservationBlack.png")}
                    />
                  </div>

                  <div>
                    <div className="f12-500">
                      {" "}
                      {props.review &&
                        props.review.diner_id &&
                        props.review.diner_id.service_type}
                    </div>
                    <span className="f10-400">
                      {" "}
                      {props.review &&
                        props.review.diner_id &&
                        props.review.diner_id._id}
                    </span>
                  </div>
                </div>
              ) : (
                <> </>
              )}
            </Col>
          </Row>
          <hr />
          <div className="d-flex align-items-center justify-content-end py-2">
            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  src={require("../../../../../assets/images/superadmin/like.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">
                  {props.review &&
                    props.review.likes &&
                    props.review.likes.length}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  className="mt-2"
                  src={require("../../../../../assets/images/superadmin/disslike.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">
                  {props.review &&
                    props.review.dislikes &&
                    props.review.dislikes.length}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div className="opacity5">
                <Image
                  fluid
                  alt="User Photo"
                  width="24px"
                  src={require("../../../../../assets/images/superadmin/chat.svg")}
                />
              </div>
              <div className="rating-review-table-body-usertextone">
                <div className="f16-400 mx-2">
                  {props.review &&
                    props.review.comment &&
                    props.review.comment.length}
                </div>
              </div>
            </div>
          </div>
          <div className="enFildset">
            <div className="enlbl f12-400">
              <span className=" opacity5">Review Comments</span>
            </div>
            <div className="f14-400">{props.review && props.review.review}</div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default ReviewDetails;
